import React from 'react';
import { useHistory } from 'react-router-dom';
import ViewList from '@material-ui/icons/List';
import { ROUTES } from 'shared/constants/routes';
import { Container, OrderView } from 'styles/pages/dashboard/orderManage';

const OrderManage = () => {
  const history = useHistory();
  return (
    <Container>
      <OrderView onClick={() => history.push(ROUTES.ORDERS.LINK)}>
        <ViewList fontSize='large' />
        View my orders
      </OrderView>
      <OrderView onClick={() => history.push(ROUTES.CATALOG.LINK)}>
        <ViewList fontSize='large' />
        Download Artwork Specs
      </OrderView>
    </Container>
  );
};

export default OrderManage;
